import React from "react";
import { Box, Divider, Theme, Typography, useMediaQuery } from "@mui/material";
import { useTranslation } from "react-i18next";
import { BookingTypeEnum, InvestmentTypeEnum } from "@bn/api/apiv1";
import { BookingType, CopyTypography } from "@components";
import { SecurityImage } from "@components/SecurityImage";

interface Props {
  name?: string;
  isin?: string;
  wkn?: string;
  type?: InvestmentTypeEnum;
  image?: string | null;
  bookingType?: BookingTypeEnum;
}

export const BookingWizardHeader = ({
  name,
  isin,
  wkn,
  type,
  image,
  bookingType,
}: Props) => {
  const { t } = useTranslation();
  const isLessSm = useMediaQuery((theme: Theme) =>
    theme.breakpoints.down("sm")
  );

  return (
    <Box mx={-5.5} width="calc(100% + 42px)">
      <Divider />
      <Box display="flex" alignItems="center" gap={3} px={6} py={3}>
        <SecurityImage src={image} width={50} height={50} alt={name} />
        <Box minWidth={0}>
          <Typography variant="subtitle2" noWrap>
            {name}
          </Typography>
          <Box
            display="flex"
            alignItems="center"
            columnGap={3}
            rowGap={0}
            flexWrap={isLessSm ? "wrap" : "nowrap"}
          >
            {bookingType && <BookingType type={bookingType} />}
            {type && (
              <Typography color="textSecondary" variant="body3">
                {t(`dashboardPage.dashboard.investmentsTable.types.${type}`, {
                  count: 1,
                })}
              </Typography>
            )}
            {wkn && !isLessSm && <CopyTypography>{wkn}</CopyTypography>}
            {isin && <CopyTypography>{isin}</CopyTypography>}
          </Box>
        </Box>
      </Box>
      <Divider />
    </Box>
  );
};
